"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = exports.PersistenceType = void 0;
var PersistenceType;
(function (PersistenceType) {
    PersistenceType[PersistenceType["BASIC"] = 0] = "BASIC";
    PersistenceType[PersistenceType["EMBEDDABLE"] = 1] = "EMBEDDABLE";
    PersistenceType[PersistenceType["ENTITY"] = 2] = "ENTITY";
    PersistenceType[PersistenceType["MAPPED_SUPERCLASS"] = 3] = "MAPPED_SUPERCLASS";
})(PersistenceType = exports.PersistenceType || (exports.PersistenceType = {}));
var Type = /** @class */ (function () {
    /**
     * @param ref
     * @param typeConstructor
     */
    function Type(ref, typeConstructor) {
        if (ref.indexOf('/db/') !== 0) {
            throw new SyntaxError("Type ref ".concat(ref, " is invalid."));
        }
        this.ref = ref;
        this.name = ref.substring(4);
        this._typeConstructor = typeConstructor;
    }
    Object.defineProperty(Type.prototype, "persistenceType", {
        /**
         * The persistent type of this type
         */
        get: function () {
            return -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Type.prototype, "isBasic", {
        /**
         * @type boolean
         * @readonly
         */
        get: function () {
            return this.persistenceType === PersistenceType.BASIC;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Type.prototype, "isEmbeddable", {
        /**
         * @type boolean
         * @readonly
         */
        get: function () {
            return this.persistenceType === PersistenceType.EMBEDDABLE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Type.prototype, "isEntity", {
        /**
         * @type boolean
         * @readonly
         */
        get: function () {
            return this.persistenceType === PersistenceType.ENTITY;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Type.prototype, "isMappedSuperclass", {
        /**
         * @type boolean
         * @readonly
         */
        get: function () {
            return this.persistenceType === PersistenceType.MAPPED_SUPERCLASS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Type.prototype, "typeConstructor", {
        /**
         * The type constructor of this type
         */
        get: function () {
            return this._typeConstructor;
        },
        /**
         * @param typeConstructor - sets the type constructor of this type if it is not already set
         */
        set: function (typeConstructor) {
            if (this._typeConstructor) {
                throw new Error('typeConstructor has already been set.');
            }
            this._typeConstructor = typeConstructor;
        },
        enumerable: false,
        configurable: true
    });
    return Type;
}());
exports.Type = Type;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR0EsSUFBWSxlQUtYO0FBTEQsV0FBWSxlQUFlO0lBQ3pCLHVEQUFTLENBQUE7SUFDVCxpRUFBYyxDQUFBO0lBQ2QseURBQVUsQ0FBQTtJQUNWLCtFQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFMVyxlQUFlLEdBQWYsdUJBQWUsS0FBZix1QkFBZSxRQUsxQjtBQUVEO0lBaUVFOzs7T0FHRztJQUNILGNBQXNCLEdBQVcsRUFBRSxlQUEwQjtRQUMzRCxJQUFJLEdBQUcsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxFQUFFO1lBQzdCLE1BQU0sSUFBSSxXQUFXLENBQUMsbUJBQVksR0FBRyxpQkFBYyxDQUFDLENBQUM7U0FDdEQ7UUFFRCxJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQztRQUNmLElBQUksQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUM3QixJQUFJLENBQUMsZ0JBQWdCLEdBQUcsZUFBZSxDQUFDO0lBQzFDLENBQUM7SUFqRUQsc0JBQUksaUNBQWU7UUFIbkI7O1dBRUc7YUFDSDtZQUNFLE9BQU8sQ0FBQyxDQUFDLENBQUM7UUFDWixDQUFDOzs7T0FBQTtJQU1ELHNCQUFJLHlCQUFPO1FBSlg7OztXQUdHO2FBQ0g7WUFDRSxPQUFPLElBQUksQ0FBQyxlQUFlLEtBQUssZUFBZSxDQUFDLEtBQUssQ0FBQztRQUN4RCxDQUFDOzs7T0FBQTtJQU1ELHNCQUFJLDhCQUFZO1FBSmhCOzs7V0FHRzthQUNIO1lBQ0UsT0FBTyxJQUFJLENBQUMsZUFBZSxLQUFLLGVBQWUsQ0FBQyxVQUFVLENBQUM7UUFDN0QsQ0FBQzs7O09BQUE7SUFNRCxzQkFBSSwwQkFBUTtRQUpaOzs7V0FHRzthQUNIO1lBQ0UsT0FBTyxJQUFJLENBQUMsZUFBZSxLQUFLLGVBQWUsQ0FBQyxNQUFNLENBQUM7UUFDekQsQ0FBQzs7O09BQUE7SUFNRCxzQkFBSSxvQ0FBa0I7UUFKdEI7OztXQUdHO2FBQ0g7WUFDRSxPQUFPLElBQUksQ0FBQyxlQUFlLEtBQUssZUFBZSxDQUFDLGlCQUFpQixDQUFDO1FBQ3BFLENBQUM7OztPQUFBO0lBS0Qsc0JBQUksaUNBQWU7UUFIbkI7O1dBRUc7YUFDSDtZQUNFLE9BQU8sSUFBSSxDQUFDLGdCQUFrQixDQUFDO1FBQ2pDLENBQUM7UUFFRDs7V0FFRzthQUNILFVBQW9CLGVBQXlCO1lBQzNDLElBQUksSUFBSSxDQUFDLGdCQUFnQixFQUFFO2dCQUN6QixNQUFNLElBQUksS0FBSyxDQUFDLHVDQUF1QyxDQUFDLENBQUM7YUFDMUQ7WUFDRCxJQUFJLENBQUMsZ0JBQWdCLEdBQUcsZUFBZSxDQUFDO1FBQzFDLENBQUM7OztPQVZBO0lBc0RILFdBQUM7QUFBRCxDQUFDLEFBM0dELElBMkdDO0FBM0dxQixvQkFBSSJ9